import React from 'react';

export default function FwFlagIcon({
  color = 'currentColor',
  fontSize = '16px',
}) {
  return (
    <>
      <i className='fas fa-flag' style={{ color, fontSize: fontSize }}></i>
    </>
  );
}
